import { Head, Link } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface Employee {
  id: number
  user: string
  email: string
}
interface Activity {
  id: number
  title: string
}
interface Props {
  activity: Activity
  employees: Employee[]
}

export default function Index({ activity, employees }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Marketing Activities", href: "/marketing_activities" },
    { title: activity.title, href: `/marketing_activities/${activity.id}` },
    {
      title: "Employees",
      href: `/marketing_activities/${activity.id}/employees`,
    },
  ]
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`${activity.title} - Employees`} />
      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">
            Employees for {activity.title}
          </h1>
          <Link
            href={`/marketing_activities/${activity.id}/employees/new`}
            className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white"
          >
            Add Employee
          </Link>
        </div>
        {employees.length > 0 ? (
          <table className="border-hpi-light-gray w-full border-collapse border">
            <thead>
              <tr className="bg-hpi-pale-gray">
                <th className="border px-4 py-2 text-left">Name</th>
                <th className="border px-4 py-2 text-left">Email</th>
                <th className="border px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {employees.map((e) => (
                <tr key={e.id}>
                  <td className="border px-4 py-2">{e.user}</td>
                  <td className="border px-4 py-2">{e.email}</td>
                  <td className="border px-4 py-2">
                    <Link
                      href={`/marketing_activities/${activity.id}/employees/${e.id}`}
                      method="delete"
                      as="button"
                      className="text-hpi-red"
                    >
                      Remove
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-hpi-med-gray">No employees assigned.</p>
        )}
      </div>
    </AppLayout>
  )
}
